import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledAsideTabContainer = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        padding: 0 ${spacing * 4}px;
        border-bottom: 1px solid ${palette.neutral['300']};
    `
)
